<template>
  <div>
    <b-form-select v-model="incidence" :options="incidencies_select" data-live-search="true" class="mb-3">
      <template slot="first">
        <option v-if="newTicket" :value="null" selected disabled>-- Selecciona una incidencia --</option>
      </template>
    </b-form-select>
  </div>
</template>

<script>
export default {
  props: {
    newTicket: {
      required: false,
      type: Boolean
    },
    incidencia: {
      required: false,
      type: Object
    },
    group: {
      required: true
    }
  },
  computed: {
    incidences () {
      return this.$store.state.incidences
    }
  },
  data () {
    return {
      selected: null,
      // Arrays del select
      incidencies_select: [],
      // Información escogida por el usuario
      incidence: this.incidencia ? this.incidencia.id : null
    }
  },
  created () {
    // Cogemos las incidencias y las formateamos para que se vean en el select
    if (this.newTicket) {
      this.$store.dispatch('fetchIncidences')
    } else {
      this.$store.dispatch('fetchIncidences').then(() => {
        this.incidencies_select = this.incidences.filter(incidence => incidence.id_grup === this.group).map(grup =>
          ({
            value: grup.id,
            text: grup.descripcio
          }))
        return this.incidencies_select
      }, {})
    }
  },
  watch: {
    group: function (newVal) {
      if (newVal !== null) {
        this.incidencies_select = this.incidences.filter(
          incidence => incidence.id_grup === this.group
        ).map(incidence => ({
          value: incidence.id,
          text: incidence.descripcio
        }))
      }
      this.incidence = null
    },
    // Cuando seleccione una incidencia filtramos y aviso al elemento parent para que pille la info
    incidence: function (newId) {
      if (newId !== null) {
        this.$emit('changeIncidence', {
          id: newId,
          descripcio: this.incidence.descripcio
        })
      } else {
        this.$emit('changeIncidence', null)
      }
    }
  }
}
</script>

<style scoped>

</style>
